// Helperi za pripremu podataka za štampu QR nalepnica (print.simons.rs)

// Serijski brojevi u bazi su neuredni: "049" -> "49", "0876 speed wash" -> "876",
// prazno/tekst bez cifara -> "" (korisnik unosi ručno u modalu)
export const cleanSerial = (raw) => {
  const match = String(raw ?? "").match(/\d+/);
  if (!match) return "";
  return match[0].replace(/^0+/, "");
};

// "PROV_39D758" -> "39D758"; sve ostalo -> "" — QR na nalepnici se gradi kao
// PROV_<kod>, pa bi sirova MAC adresa dala neupotrebljivu nalepnicu
export const macToProvCode = (mac) => {
  const value = String(mac ?? "").trim().toUpperCase();
  return value.startsWith("PROV_") ? value.slice(5) : "";
};

export const SERIAL_REGEX = /^[1-9]\d{0,5}$/;
export const PROV_CODE_REGEX = /^[A-Z0-9-]+$/i;
